import { HttpClient } from '../HttpClient';

/**
 * Get UserSetting Given Employee Id
 */
export const GetUserSetting = async (employeeId) => {
  try {
    const { data } = await HttpClient.get(`api/usersettings/${employeeId}`);
    return data;
  } catch (err) {
    throw new Error(err.message || 'Failed to get user setting');
  }
};
